/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface TextSnippetPermissions {
    change: boolean;
    share: boolean;
    destroy: boolean;
}
export const TextSnippetPermissions_change_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TextSnippetPermissions_share_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TextSnippetPermissions_destroy_Validators: ValidatorFn[] =
    [  Validators.required, ];


